(function(){
    "use strict";
    
    angular
        .module("app")
        .component("cart", { // cart
            templateUrl: "src/app/cart/cart.html",
            controller: controller
        });

    function controller($location, session, CART_TYPE_CODE) {
        const $ctrl = this;
        $ctrl.session = session;

        $ctrl.canProceed = () => session.cart.items.every(item => !item.isUpdating);

        $ctrl.proceedClicked = () => {
            $location.path("/checkout");
        };

        $ctrl.cartTypeName = () => {
            if (session.cartTypeCode === CART_TYPE_CODE.CSOS)
                return "Controlled Substances Cart";
            return "Cart";
        };

        $ctrl.showBundleSuggest = () => {
            //return !$ctrl.session.cart.items.some(i => i.incentives.filter(i => i.incentive_type_Code === "BND").length > 0);
            return false;
        };
    }
    controller.$inject = ["$location", "sessionService", "CART_TYPE_CODE"];
    
})()